import { defineAsyncComponent } from "vue";

const ShowActiveUserSessions = defineAsyncComponent(
  () => import("./ShowActiveUserSessions.vue"),
);

export { ShowActiveUserSessions };
